import React from 'react';
import { parseDate } from 'utils/date';
import { splitSsn } from 'utils/strings';
import { usePortfolioTranslation as useLocale } from 'jsx/hooks/useTranslation';

import { DD_REGISTRY_MAPPING } from 'constants/portfolio';

export default function DDRow({ item }) {
  const { t } = useLocale();
  const {
    ddName,
    eventDate,
    firmRegistryLink,
    libraLink,
    trend,
    ruleID,
    ruleName,
    severityGroupID,
    subjectName,
    subjectRegno,
    typeID,
  } = item;
  const business = process.env.REACT_APP_BUSINESS_WEB_URL;
  const firmUrl = `${business}/Search/Search.aspx?${firmRegistryLink}`;
  const libraUrl = `${business}/Reports/Libra.aspx?${libraLink}`;

  const ddSub =
    trend === 'D' ? t('monitor_ddrow_ddremove') : t(DD_REGISTRY_MAPPING[severityGroupID]);
  const ddCls = `text-bold ${trend === 'D' ? 'text-green' : 'text-red'}`;
  const ddText =
    t(`ddType_${typeID}`) ||
    t(`ddType_rule_${ruleID}`) ||
    ruleName ||
    ddName ||
    t('portfolioMonitoring_ddEvents_base_dd_event');

  return (
    <tr className="text-gray-darker">
      <td>{parseDate(eventDate)}</td>
      <td>
        <div>
          <a href={firmUrl} target="_blank" rel="noopener noreferrer">
            {subjectName}
          </a>
        </div>
        <div>{splitSsn(subjectRegno)}</div>
      </td>
      <td>
        <div className={ddCls}>{ddText}</div>
        <div className="text-semibold">{ddSub}</div>
      </td>
      <td>
        <a target="_blank" href={libraUrl} rel="noopener noreferrer">
          {`${t('portfolioMonitoring_ddEvents_view_libra')} `}
        </a>
      </td>
    </tr>
  );
}
